import { ENTITY_TYPE_TERRAIN } from "./constants.js"

export class Terrain {

    static ByType(type, x, y) {
        switch (type) {
            case 0: 
                return Terrain.Plain(x,y)
        }
    }

    static Plain = (x,y) => {
        return new Terrain (
            1,
            'plain',
            { x, y },
            true,
        )
    }

    static Rock = (x,y) => {
        return new Terrain (
            100,
            'rock',
             { x, y },
             false,
        )
    }

    static Tree = (x,y) => {
        return new Terrain (
            100,
            'tree',
            { x, y },
            false,
        )
    }

    static Water = (x,y) => {
        return new Terrain (
            100,
            `water`,
            { x, y },
            true,
        )
    }

    constructor(cost, name, position, traversibleByRanged) {
        this.cost = cost
        this.name = name
        this.position = position
        this.traversibleByRanged = traversibleByRanged
        this.type = ENTITY_TYPE_TERRAIN
    }

    isAlive() {
        return false
    }
}